import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";


const _base = "zxStudentHomeworkDetail/";

// 作业详情 - 获取作业详情列表
export const homeWorkList = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "list", {
    data: _params,
    method: "GET"
  });
};

// 作业详情 - 获取作业详情
export const homeWorkView = params => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "view", {
           data: _params,
           method: "GET"
         });
       };



// WEBPACK FOOTER //
// ./src/fetch/api/homeworkDetail.js